import { Component } from '@angular/core';
import { BaseComponent } from '@shared/lib/components/base.component';

@Component({
  selector: 'u-boss',
  templateUrl: './boss.component.html',
  styleUrls: ['./boss.component.scss'],
  providers: [{ provide: BaseComponent, useExisting: BossComponent }],
})
export class BossComponent extends BaseComponent {
  src = 'boss';
  map = {
    image: 'image',
    heading: 'heading',
    subheading: 'subheading',
    text: 'text',
    quotes: [
      {
        quoteText: 'quotes.0.quoteText',
        quoteImage: 'quotes.0.quoteImage',
        quoteAuthor: 'quotes.0.quoteAuthor',
        quoteTitle: 'quotes.0.quoteTitle',
      },
      {
        quoteText: 'quotes.1.quoteText',
        quoteImage: 'quotes.1.quoteImage',
        quoteAuthor: 'quotes.1.quoteAuthor',
        quoteTitle: 'quotes.1.quoteTitle',
      },
      {
        quoteText: 'quotes.2.quoteText',
        quoteImage: 'quotes.2.quoteImage',
        quoteAuthor: 'quotes.2.quoteAuthor',
        quoteTitle: 'quotes.2.quoteTitle',
      },
    ],
  };
}
